import React, { useCallback } from 'react';
import * as Styles from './Styles';
import { useSelector } from 'react-redux';
import * as LoginManager from '../../../reducers/ui/login';
import * as AppDataManager from '../../../reducers/data/app';
import { Form } from './Form';
import { TwoFactor } from './TwoFactor';
import { useLifecycles } from 'react-use';

type Props = {};

export const Panel = (_props: Props) => {
	const step = useSelector(LoginManager.Selectors.getStep);

	const handleEnterKeyPress = useCallback(async (e: KeyboardEvent) => {
		if (e.code === 'Enter') {
			await AppDataManager.loginApp();
		}
	}, []);

	useLifecycles(
		() => {
			window.addEventListener('keypress', handleEnterKeyPress);
		},
		() => {
			window.removeEventListener('keypress', handleEnterKeyPress);
		}
	);

	return (
		<Styles.Wrapper>
			<Styles.LeftSection twoFactorActive={step === 'confirm'}>
				{step === 'form' ? <Form /> : <TwoFactor />}
			</Styles.LeftSection>
		</Styles.Wrapper>
	);
};
